import { IPrintAreas, IProductJSONFromHTML } from "src/components/productConfiguration/type";
import { errorMessages } from "../assets/config";
import {fabric} from "fabric"

export const qtyProxy: {
    [key: string]: any
} = new Proxy({}, {
    set (obj, key, value) {
        // Update the property
        obj[key] = value;
        // Find the matching fields in the DOM
        // @ts-ignore
        const fields = document.querySelectorAll(`[name="${key}"]`);
        for (const field of fields) {
            // @ts-ignore
            field.value = value;
        }
        return true;
    }
});


export const appendElementWithId = (id?: string, content?: any, callbackFn?: () => void) => {
    if (checkToLoadScriptFoOdoo()) {
        return;
    }
    
    if (!content || !id) return alert(errorMessages.SERVER_ERROR);
    const mainContent = document.getElementById(id);
    if (typeof content === "object") {
        mainContent.appendChild(content);
        if (callbackFn) callbackFn()
        return
    }
    mainContent.appendChild(new DOMParser().parseFromString(content, "text/html").body.firstChild);
    if (callbackFn) callbackFn()
}

export const replaceCurrentElementWithNewId = (id?: string, content?: any, route?: any, callbackFn?: () => void) => {
    if (checkToLoadScriptFoOdoo()) {
        return;
    }
    if (!content || !id) return alert(errorMessages.SERVER_ERROR);
    const mainContent = document.getElementById(id);
    if (route) localStorage.setItem('previousNode', route);
    if (typeof content === "object") {
        mainContent.replaceChild(content, mainContent.firstChild)
        if (callbackFn) callbackFn()
        return
    }
    mainContent.replaceChild(new DOMParser().parseFromString(content, "text/html").body.firstChild, mainContent.firstChild)
    if (callbackFn) callbackFn()
}

/*
* section : The main container or div in which you need to replace html.
* newContent : new HTML in string
*/
export const replaceInnerChildElements = (section : HTMLElement, newContent : string) =>{
    section.innerHTML = ""
    section.appendChild(new DOMParser().parseFromString(newContent, "text/html").body.firstChild);
}

/*
* id : input box id you want to clear
*/
export const clearInputBoxHandler = (id : string) =>{
    (document.getElementById(id) as HTMLInputElement).value = "";
}


export const setLoader = (isLoading : boolean) => {
    const loader = document.getElementById("loadingSceen");
    loader.style.display = isLoading ? "flex" : "none";
};

export const setPopupLoader = (isLoading : boolean) => {
    const loader = document.getElementById("popupLoader");
    loader.style.display = isLoading ? "flex" : "none";
};

export function hexToRgb(hex) {
    let result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
    return result ? [
        parseInt(result[1], 16),
        parseInt(result[2], 16),
        parseInt(result[3], 16)
    ] : null;
}

export function rgbToHex(r: number, g: number, b: number): string {
    return "#" + (1 << 24 | r << 16 | g << 8 | b).toString(16).slice(1);
}


export const compareArr = (arr1, arr2) => {
    if (!arr1 || !arr2) return false;
    if (arr1.length === 0 || arr2.length === 0) return false;
    if(arr1.length !== arr2.length){ return false;}
    return arr1.every((item, index) => item == arr2[index]);
};

export function uniqBy(a, key) {
    // @ts-ignore
    let seen = new Set();
    return a.filter(item => {
        let k = key(item);
        return seen.has(k) ? false : seen.add(k);
    });
}

export function conversionToHex(color: string) {
    let newColor = color;
    if (color.includes('rgb')) {
        const array = color.replace("rgb(", "").replace(")","").split(",");
        newColor = rgbToHex(Number(array[0]), Number(array[1]), Number(array[2]));
    }
    return newColor
}


// Function to calculate Euclidean distance between two colors
export function colorDistance(color1, color2) {
    let rDiff = color1[0] - color2[0];
    let gDiff = color1[1] - color2[1];
    let bDiff = color1[2] - color2[2];
    return Math.sqrt(rDiff * rDiff + gDiff * gDiff + bDiff * bDiff);
}


/**
 * Transforms an array of product data into a print areas format.
 *
 * @param {IProductJSONFromHTML[]} inputs - An array of product data objects containing techniques and sections information.
 * @returns {IPrintAreas} - Returns an object that maps product data to print areas, including transformed data such as positioning, sizes, and technique details.
 */
export function transformData(inputs : IProductJSONFromHTML[]): IPrintAreas {

    const printAreas = inputs?.map((input)=>{
    const section = input.availableTechniques[0].availableSections[0];
    
    return {
        name: input.name,
        sku: input.sku,
        brandingAreas: [
            {
                defaultImage_id: section.defaultImage_id,
                top: parseInt(section.top),
                left: parseInt(section.left),
                detail_height: section.detail_height,
                detail_width: section.detail_width,
                height: parseInt(section.height),
                width: parseInt(section.width),
                id: section.id.toString(),
                availableTechniques: [
                    {
                        techniqueName: input.availableTechniques[0].techniqueName,
                        isRecommended: input.availableTechniques[0].isRecommended === "true",
                        maxColor: input.availableTechniques[0].maxColor,
                        daysRequire: input.availableTechniques[0].daysRequire,
                        id: input.availableTechniques[0].id,
                        sku: input.sku,
                        name: input.name,
                        currentTechnique: input.pricing_product_name,
                        is_single_color_selected: !!section?.single_color,
                        selected_color : section?.single_color,
                        selected_color_count: +section?.color_choice_value,
                    }
                ]
            }
        ]
    };
    });
    return printAreas;

}

export const getBrandingDetailUrl = (url : string, productId: string,variantId: string) =>{
    return `${url}/api/get_branding_details?logo_id=${productId}&&variant_id=${variantId}`
}

export const getImageBase64FromIdUrl = (url : string, id: string) =>{
    return `${url}/api/get_branding_details?defaultImage_id=${id}`
}

export const getPostBrandingDetails = (url : string) => {
    return `${url}/shop/post_branding_details`;
}

export const getShoCartRedirectUrl = (url : string) => {
    return `${url}/shop/cart`;
}

export const getAddLogoToLibraryUrl = (url : string) => {
    return `${url}/api/logo_library`;
}

export const getFetchEditProductJsonUrl = (url : string, id : string) => {
    return `${url}/api/get_edit_info?so_line_id=${id}`;
}

export const checkToLoadScriptFoOdoo = () => {
    if (!window?.location?.pathname?.split("/")?.includes("logo-builder")) {
        return true;    
    }

    return false;
};

export const getSelectedTechnique = () => {
    return qtyProxy['canvasListForPosition']?.[qtyProxy['selectedPositionIndex']]?.selectedTechnique;
}

export const getSelectedBrandingArea = () => {
    return qtyProxy['canvasListForPosition']?.[qtyProxy['selectedPositionIndex']]?.selectedBrandingArea;
}

export const getCurrentCanvas = () => {
    return qtyProxy['canvasListForPosition']?.[qtyProxy['selectedPositionIndex']]?.canvas;
}

export const getUpdatedHistory = () => {
    return qtyProxy['canvasListForPosition']?.[qtyProxy['selectedPositionIndex']]?.updatedHistory;
}

export const getCanvasEditor = () => {
    return qtyProxy['canvasListForPosition']?.[qtyProxy['selectedPositionIndex']]?.canvasEditor;
}

export const getDrawableArea = () => {
    return qtyProxy['canvasListForPosition']?.[qtyProxy['selectedPositionIndex']]?.drawableArea;
};

export const getCurrentProductNameAndSku = () => {
    return {
        techniqueName : getSelectedTechnique()?.techniqueName,
        sku: getSelectedTechnique()?.sku,
        name: getSelectedTechnique()?.name,
        currentTechnique:  qtyProxy['canvasListForPosition']?.[qtyProxy['selectedPositionIndex']]?.currentTechnique
    }
};
export  function getImageDimensions(base64: string): Promise<{ width: number, height: number }> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        resolve({ width: img.width, height: img.height });
      };
      img.onerror = reject;
      
      // Ensure the full data URL is passed
      img.src = base64;
    });
}

export function resizeImage(base64: string, newWidth: number, newHeight: number): Promise<string> {
    return new Promise((resolve, reject) => {
      const img = new Image();
      img.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = newWidth;
        canvas.height = newHeight;
  
        const ctx = canvas.getContext("2d");
        if (ctx) {
          ctx.drawImage(img, 0, 0, newWidth, newHeight);
          resolve(canvas.toDataURL());
        } else {
            reject(new Error("Failed to get 2D context")); 
        }
      };
      img.onerror = () => reject(new Error("Image loading failed"));
      img.src = base64;
    });
  }


  export function createSvgFromText(text,textObj) {
    const tempCanvas = document.createElement('canvas');
    tempCanvas.setAttribute('id',"textCanvas");
    const canvas = new fabric.Canvas('textCanvas');
        // Create a text object
        const textObjC = new fabric.Text(text,textObj);

        // Add the text object to the canvas
        canvas.add(textObjC);

        // Calculate the dimensions to set the canvas
        const textWidth = textObj.width; // Width of the text
        const textHeight = textObj.height; // Height of the text

        // Resize the canvas to match the text dimensions
        canvas.setWidth(textWidth + 10);
        canvas.setHeight(textHeight);
        const svgString = canvas.toSVG();
        return svgString
  };

  export const getSVGCords = (textObj,overlayImgScaleX,overlayImgScaleY) => {
    return  {
        width: (textObj.width * textObj.scaleX)/overlayImgScaleX,
        height: (textObj.height * textObj.scaleY)/overlayImgScaleY,
        scaleX: textObj.scaleX / overlayImgScaleX ,
        scaleY: textObj.scaleY / overlayImgScaleY,
        text: textObj?.text,
        fontFamily: textObj?.fontFamily,
        fontSize: textObj?.fontSize,
        fontWeight: textObj?.fontWeight,
        fontStyle: textObj?.fontStyle,
        fill: textObj?.fill,
        underline: textObj?.underline,
        textAlign: textObj?.textAlign,
        left: 0,
        top: 0,
      };
  }

  export function validateNumericInput(event) {
    // Allow only numeric keys (0-9), Backspace, Delete, Arrow keys, Tab, etc.
    const allowedKeys = [
      "Backspace", "Delete", "ArrowLeft", "ArrowRight", "Tab","ArrowUp", "ArrowDown", "Enter"
    ];
    const isNumber = /^[0-9]$/.test(event.key);
  
    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault(); // Prevent the key press
    }
  }